import { Route } from "react-router-dom";

import { RequireAuth } from "../../services/auth";

import ListPublicHoliday from "./ListPublicHoliday";
import PublicHoliday from "./PublicHoliday";
import AddPublicHoliday from "./AddPublicHoliday";
import EditPublicHoliday from "./EditPublicHoliday";
import ViewPublicHoliday from "./ViewPublicHoliday";

export default (
  <Route
    path="publicHoliday"
    element={
      <RequireAuth>
        <PublicHoliday />
      </RequireAuth>
    }
  >
    <Route
      index
      element={
        <RequireAuth>
          <ListPublicHoliday />
        </RequireAuth>
      }
    />
    <Route
      path="new"
      element={
        <RequireAuth>
          <AddPublicHoliday />
        </RequireAuth>
      }
    />
    <Route
      path="edit/:id"
      element={
        <RequireAuth>
          <EditPublicHoliday />
        </RequireAuth>
      }
    />

  </Route>
);
